import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { getOptionsQueryParams } from "@app/class/Utilities";
import { ICameraRequestUpdateMessage } from "@app/main/modules/foundation/_routes/developerConsole/log-message.model";
import { SignalRService, WebSocketEvents } from "@app/main/modules/foundation/_routes/developerConsole/signalr.service";
import { IConfigCameraRequest, IConfigurationRequestQueryOptions } from "@app/main/modules/foundation/_routes/rv-lite/camera-config/camera-configuration.models";
import { Observable, Subject } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class CameraConfigurationRequestService {

    constructor(
        private readonly http: HttpClient,
        private readonly signalRService: SignalRService) { }

    configRequestUpdateReceived = new Subject<ICameraRequestUpdateMessage>();

    getConfigurationRequests(queryOptions: IConfigurationRequestQueryOptions): Observable<IConfigCameraRequest[]> {
        const params = getOptionsQueryParams(queryOptions);
        return this.http.get<IConfigCameraRequest[]>(`/api/cameras/commserver/configurations/requests`, params);
    }

    postConfigurationRequest(configRequest: IConfigCameraRequest): Observable<IConfigCameraRequest> {
        return this.http.post<IConfigCameraRequest>(`/api/cameras/commserver/configurations/requests`, configRequest);
    }

    getConfigurationRequestUpdates(serial: string): Observable<ICameraRequestUpdateMessage> {
        this.signalRService.initialise().then(() => {
            this.signalRService.joinDeviceGroup(serial);
            this.signalRService.registerEvents<ICameraRequestUpdateMessage>(WebSocketEvents.LogRequestUpdate, this.configRequestUpdateReceived);
        });

        return this.configRequestUpdateReceived;
    }
}
